import React from 'react';
import { X } from 'lucide-react';

/**
 * Listening Chain
 *
 * Wraps the self-contained HTML module hosted at /modules/listening-chain.html
 * in an iframe. A single floating exit button lets the user return to the
 * Voice Integration module hub without breaking the module's own back/forward
 * navigation, which lives inside the iframe.
 */
const ListeningChain = ({ onExit }) => {
  return (
    <div
      className="fixed inset-0 bg-[#1A1A1A] z-40 flex flex-col"
      data-testid="listening-chain"
    >
      <button
        onClick={onExit}
        aria-label="Exit Listening Chain"
        data-testid="listening-chain-exit"
        className="absolute top-safe-3 right-3 z-50 w-9 h-9 rounded-full bg-[#1A1A1A]/80 border border-[#F5F2EB]/15 text-[#F5F2EB]/70 hover:text-[#F5F2EB] hover:border-[#F5F2EB]/35 backdrop-blur flex items-center justify-center transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
      <iframe
        src="/modules/listening-chain.html"
        title="The Listening Chain"
        className="flex-1 w-full border-0"
        allow="microphone; autoplay; fullscreen; encrypted-media"
      />
    </div>
  );
};

export default ListeningChain;
